<template>
  <div class="main">
    <div class="curse-content">
      <div class="curse-tex">
        当前位置：首页>结项评审资料上传>结项评审资料详情
      </div>
    </div>
    <!--  -->
    <div class="list-content">
      <!-- 项目名称标题：居中、加粗 -->
      <h2 style="text-align: center; margin-bottom: 20px">
        {{ projectInfo.project_name }}
      </h2>
      <!-- 表单 -->
      <div class="form_box">
        <!--  -->
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-position="top"
        >
          <el-form-item prop="end_project_contract">
            <div class="boxMain">
              <div class="form-tit">
                <i></i>
                <b>项目实施方案（合同签订版）</b>
              </div>

              <div style="color: red; margin-top: -30px">
                注：请上传合同签订版项目实施方案PDF文件。
              </div>

              <el-row :gutter="24">
                <el-col :span="6">
                  <upload-file
                    class="flex justify-start"
                    name="end_project_contract"
                    auth
                    @uploadFile="uploadFile"
                    :size="200"
                  >
                    <div class="image text-left" slot="upload">
                      <div
                        slot="error"
                        class="image-slot text-gray flex flex-direction align-center justify-center"
                      >
                        <i class="iconfont icon-yunshangchuan"></i>
                        <div>上传文件</div>
                        <p>支持上传pdf/word/zip/xlsx格式文件200MB以内</p>
                      </div>
                    </div>
                  </upload-file>
                </el-col>
              </el-row>

              <div class="ziplist">
                <div
                  class="zip-item"
                  v-for="(item, index) in ruleForm.end_project_contract"
                  :key="index"
                >
                  <a :href="item.href" target="_blank">{{ item.name }}</a>
                  <span @click="handleDelete(index, 'end_project_contract')"
                    >删除</span
                  >
                </div>
              </div>
            </div>
          </el-form-item>

          <el-form-item prop="end_report_file">
            <div class="boxMain">
              <div class="form-tit">
                <i></i>
                <b>《项目结项自评报告》WORD版及盖章PDF版</b>
              </div>

              <div style="color: red; margin-top: -30px">
                注：请上传《项目结项自评报告》WORD版及盖章PDF版文件。
              </div>

              <el-row :gutter="24">
                <el-col :span="6">
                  <upload-file
                    class="flex justify-start"
                    name="end_report_file"
                    auth
                    @uploadFile="uploadFile"
                    :size="200"
                  >
                    <div class="image text-left" slot="upload">
                      <div
                        slot="error"
                        class="image-slot text-gray flex flex-direction align-center justify-center"
                      >
                        <i class="iconfont icon-yunshangchuan"></i>
                        <div>上传文件</div>
                        <p>支持上传pdf/word/zip/xlsx格式文件200MB以内</p>
                      </div>
                    </div>
                  </upload-file>
                </el-col>
              </el-row>

              <div class="ziplist">
                <div
                  class="zip-item"
                  v-for="(item, index) in ruleForm.end_report_file"
                  :key="index"
                >
                  <a :href="item.href" target="_blank">{{ item.name }}</a>
                  <span @click="handleDelete(index, 'end_report_file')"
                    >删除</span
                  >
                </div>
              </div>
            </div>
          </el-form-item>

          <el-form-item prop="end_finance_file">
            <div class="boxMain">
              <div class="form-tit">
                <i></i>
                <b>财务预决算对照表（Excel及PDF盖章版）</b>
              </div>

              <div style="color: red; margin-top: -30px">
                注：请上传项目财务预决算对照表Excel版及PDF盖章版文件。
              </div>

              <el-row :gutter="24">
                <el-col :span="6">
                  <upload-file
                    class="flex justify-start"
                    name="end_finance_file"
                    auth
                    @uploadFile="uploadFile"
                    :size="200"
                  >
                    <div class="image text-left" slot="upload">
                      <div
                        slot="error"
                        class="image-slot text-gray flex flex-direction align-center justify-center"
                      >
                        <i class="iconfont icon-yunshangchuan"></i>
                        <div>上传文件</div>
                        <p>支持上传pdf/word/zip/xlsx格式文件200MB以内</p>
                      </div>
                    </div>
                  </upload-file>
                </el-col>
              </el-row>

              <div class="ziplist">
                <div
                  class="zip-item"
                  v-for="(item, index) in ruleForm.end_finance_file"
                  :key="index"
                >
                  <a :href="item.href" target="_blank">{{ item.name }}</a>
                  <span @click="handleDelete(index, 'end_finance_file')"
                    >删除</span
                  >
                </div>
              </div>
            </div>
          </el-form-item>

          <el-form-item prop="end_record_file">
            <div class="boxMain">
              <div class="form-tit">
                <i></i>
                <b>项目过程档案资料</b>
              </div>

              <div style="color: red; margin-top: -30px">
                注：请上传项目过程档案资料，以活动类资料为例，包括但不限于活动通知、活动方案、签到表、活动简报、媒体报道、活动精选照片2-3张等，请将各项材料清晰命名，以压缩包格式提交。
              </div>

              <el-row :gutter="24">
                <el-col :span="6">
                  <upload-file
                    class="flex justify-start"
                    name="end_record_file"
                    auth
                    @uploadFile="uploadFile"
                    :size="200"
                  >
                    <div class="image text-left" slot="upload">
                      <div
                        slot="error"
                        class="image-slot text-gray flex flex-direction align-center justify-center"
                      >
                        <i class="iconfont icon-yunshangchuan"></i>
                        <div>上传文件</div>
                        <p>支持上传pdf/word/zip/xlsx格式文件200MB以内</p>
                      </div>
                    </div>
                  </upload-file>
                </el-col>
              </el-row>

              <div class="ziplist">
                <div
                  class="zip-item"
                  v-for="(item, index) in ruleForm.end_record_file"
                  :key="index"
                >
                  <a :href="item.href" target="_blank">{{ item.name }}</a>
                  <span @click="handleDelete(index, 'end_record_file')"
                    >删除</span
                  >
                </div>
              </div>
            </div>
          </el-form-item>

          <el-form-item prop="end_financial_data">
            <div class="boxMain">
              <div class="form-tit">
                <i></i>
                <b>财务资料</b>
              </div>

              <div style="color: red; margin-top: -30px">
                注：请上传项目相关财务资料，请将各项材料清晰命名，以压缩包格式提交。
              </div>

              <el-row :gutter="24">
                <el-col :span="6">
                  <upload-file
                    class="flex justify-start"
                    name="end_financial_data"
                    auth
                    @uploadFile="uploadFile"
                    :size="200"
                  >
                    <div class="image text-left" slot="upload">
                      <div
                        slot="error"
                        class="image-slot text-gray flex flex-direction align-center justify-center"
                      >
                        <i class="iconfont icon-yunshangchuan"></i>
                        <div>上传文件</div>
                        <p>支持上传pdf/word/zip/xlsx格式文件200MB以内</p>
                      </div>
                    </div>
                  </upload-file>
                </el-col>
              </el-row>

              <div class="ziplist">
                <div
                  class="zip-item"
                  v-for="(item, index) in ruleForm.end_financial_data"
                  :key="index"
                >
                  <a :href="item.href" target="_blank">{{ item.name }}</a>
                  <span @click="handleDelete(index, 'end_financial_data')"
                    >删除</span
                  >
                </div>
              </div>
            </div>
          </el-form-item>

          <el-form-item prop="end_ppt_file">
            <div class="boxMain">
              <div class="form-tit">
                <i></i>
                <b>汇报PPT（可编辑版及PDF版）</b>
              </div>

              <div style="color: red; margin-top: -30px">
                注：请上传结项评估汇报PPT可编辑版及PDF版文件。
              </div>

              <el-row :gutter="24">
                <el-col :span="6">
                  <upload-file
                    class="flex justify-start"
                    name="end_ppt_file"
                    auth
                    @uploadFile="uploadFile"
                    :size="200"
                  >
                    <div class="image text-left" slot="upload">
                      <div
                        slot="error"
                        class="image-slot text-gray flex flex-direction align-center justify-center"
                      >
                        <i class="iconfont icon-yunshangchuan"></i>
                        <div>上传文件</div>
                        <p>支持上传pdf/word/zip/xlsx格式文件200MB以内</p>
                      </div>
                    </div>
                  </upload-file>
                </el-col>
              </el-row>

              <div class="ziplist">
                <div
                  class="zip-item"
                  v-for="(item, index) in ruleForm.end_ppt_file"
                  :key="index"
                >
                  <a :href="item.href" target="_blank">{{ item.name }}</a>
                  <span @click="handleDelete(index, 'end_ppt_file')">删除</span>
                </div>
              </div>
            </div>
          </el-form-item>

          <el-form-item style="text-align: center">
            <el-button
              type="primary"
              @click="submitForm('ruleForm')"
              style="width: 200px; height: 50px; font-size: 16px"
            >
              提交资料
            </el-button>
            <el-button
              style="width: 200px; height: 50px; font-size: 16px"
              @click="$router.go(-1)"
            >
              返回列表
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getProjectDetail,
  saveProjectFileList,
  saveEndProjectFileList,
} from "@/api/index";

import { zhDate } from "@/tools";

import UploadFile from "@/components/UploadFile";

import { baseURL } from "@/config";

export default {
  name: "detail",
  data() {
    return {
      zhDate: zhDate,

      baseURL: baseURL,

      ruleForm: {
        id: 0,
        // 项目实施方案（合同签订版）
        end_project_contract: [],
        // 《项目结项自评报告》WORD版及盖章PDF版
        end_report_file: [],
        // 汇报PPT（可编辑版及PDF版）
        end_ppt_file: [],
        // 财务预决算对照表
        end_finance_file: [],
        // 项目过程档案资料
        end_record_file: [],
        // 财务资料
        end_financial_data: [],
      },

      rules: {
        end_project_contract: [
          {
            required: true,
            message: "请上传项目实施方案（合同签订版）",
            trigger: "blur",
          },
        ],

        end_report_file: [
          {
            required: true,
            message: "请上传《项目结项自评报告》WORD版及盖章PDF版",
            trigger: "blur",
          },
        ],

        // end_ppt_file: [
        //   {
        //     required: true,
        //     message: "请上传汇报PPT（可编辑版及PDF版）",
        //     trigger: "blur",
        //   },
        // ],

        end_finance_file: [
          {
            required: true,
            message: "请上传财务预决算对照表",
            trigger: "blur",
          },
        ],

        end_record_file: [
          {
            required: true,
            message: "请上传项目过程档案资料",
            trigger: "blur",
          },
        ],

        end_financial_data: [
          {
            required: true,
            message: "请上传财务资料",
            trigger: "blur",
          },
        ],
      },

      projectInfo: [],

      projectId: 0,
    };
  },
  computed: {
    token() {
      return this.$store.state.shzztoken;
    },
  },
  components: { UploadFile },

  async created() {
    this.$emit("setActive", {
      active: 4,
    });

    let params = this.$route.query;

    this.projectId = params.id ? parseInt(params.id) : 0;

    if (this.projectId > 0) {
      await this.getProjectDetail();

      this.ruleForm.id = this.projectId;
    }
  },

  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.saveInfo(0);
        } else {
          console.log("error submit!!");
          this.$message.error("请上传完整资料");
          return false;
        }
      });
    },
    async saveInfo(is_save = 1) {
      let ruleForm = JSON.parse(JSON.stringify(this.ruleForm));

      ruleForm.end_project_contract = JSON.stringify(
        ruleForm.end_project_contract
      );

      ruleForm.end_report_file = JSON.stringify(ruleForm.end_report_file);

      ruleForm.end_ppt_file = JSON.stringify(ruleForm.end_ppt_file);

      ruleForm.end_finance_file = JSON.stringify(ruleForm.end_finance_file);

      ruleForm.end_record_file = JSON.stringify(ruleForm.end_record_file);

      ruleForm.end_financial_data = JSON.stringify(ruleForm.end_financial_data);

      ruleForm.id = this.projectId;

      let { code, message, data } = await saveEndProjectFileList(ruleForm);

      if (code === 200) {
        this.$message.success("结项评审资料提交成功");

        this.getProjectDetail();
      } else {
        this.$message.error("结项评审资料提交失败");
      }
    },
    /**
     *
     */
    async getProjectDetail() {
      let { code, data } = await getProjectDetail({
        id: this.projectId,
      });

      if (code == 200) {
        this.projectInfo = data;

        this.ruleForm = {
          id: data.id,
          // 项目实施方案（合同签订版）
          end_project_contract: data.end_project_contract
            ? JSON.parse(data.end_project_contract)
            : [],
          // 《项目结项自评报告》WORD版及盖章PDF版
          end_report_file: data.end_record_file
            ? JSON.parse(data.end_report_file)
            : [],
          // 汇报PPT（可编辑版及PDF版）
          end_ppt_file: data.end_ppt_file ? JSON.parse(data.end_ppt_file) : [],
          // 财务预决算对照表
          end_finance_file: data.end_finance_file
            ? JSON.parse(data.end_finance_file)
            : [],
          // 项目过程档案资料
          end_record_file: data.end_record_file
            ? JSON.parse(data.end_record_file)
            : [],
          // 财务资料
          end_financial_data: data.end_financial_data
            ? JSON.parse(data.end_financial_data)
            : [],
        };
      }
    },

    /**
     *
     * @param index
     * @param name
     */
    handleDelete(index, name) {
      this.ruleForm[name].splice(index, 1);
    },

    /**
     *
     * @param data
     */
    uploadFile(data) {
      // if (this.ruleForm[data.name].length >= 1) {
      //   this.$message.error("只能上传一个文件");

      //   return;
      // }

      this.ruleForm[data.name].push({
        name: data.file.name,
        href: data.file.url,
      });
    },
  },

  watch: {},

  filters: {},
};
</script>

<style scoped lang="scss">
::v-deep {
  .el-form-item__label {
    font-size: 16px;
    letter-spacing: 1px;
    color: #333333;
    line-height: 50px;
  }

  .el-input__inner {
    height: 50px;
    font-size: 16px;
    letter-spacing: 1px;
    color: #333333;
  }

  .el-textarea__inner {
    font-size: 16px;
    letter-spacing: 1px;
    color: #333333;
  }

  .el-select {
    width: 100%;
    font-size: 16px;
    letter-spacing: 1px;
    color: #333333;
  }
}

.btnbox {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 30px;
  margin-bottom: 50px;
  .tips {
    width: 100%;
    text-align: center;
    font-size: 16px;
    color: #999;
    margin-top: 10px;
  }
  .bor {
    width: 170px;
    height: 60px;
    background-color: #ffffff;
    border-radius: 10px;
    border: solid 1px #1546c5;
    text-align: center;
    line-height: 58px;
    font-size: 20px;
    letter-spacing: 2px;
    color: #1546c5;
    cursor: pointer;
    margin: 0 20px;
  }

  .bg {
    width: 170px;
    height: 60px;
    background-color: #ffffff;
    border-radius: 10px;
    text-align: center;
    line-height: 60px;
    font-size: 20px;
    letter-spacing: 2px;
    color: #ffffff;
    cursor: pointer;
    background-image: linear-gradient(90deg, #0115a6 0%, #1546c5 100%);
    margin: 0 20px;
  }
}

.image-slot {
  width: 350px;
  height: 158px;
  background-color: #ffffff;
  border: dotted 1px #d2d2d2;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;

  i {
    font-size: 60px;
    color: #e0dddd;
  }

  > div {
    width: 100%;
    text-align: center;
    font-size: 14px;
    color: #1546c5;
  }

  > P {
    width: 100%;
    text-align: center;
    font-size: 14px;
    letter-spacing: 1px;
    color: #d3d3d3;
  }
}

.ziplist {
  width: 100%;
  padding-bottom: 30px;

  .zip-item {
    width: 100%;
    height: 49px;
    background-color: #f7f7f7;
    padding: 0 20px;
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    a {
      flex: 1;
      width: 0;
      font-size: 14px;
      letter-spacing: 1px;
      color: #333333;
      cursor: pointer;
    }

    span {
      font-size: 14px;
      letter-spacing: 1px;
      color: #999;
      cursor: pointer;
    }
  }
}

.boxTop {
  width: 100%;

  .shuoming {
    width: 100%;
    padding: 10px;
    background-size: auto 10px;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.03);

    .shuoming-content {
      width: 100%;
      padding: 30px;
      background: #ffffff;

      .shuoming-tex {
        width: 100%;
        font-size: 18px;
        letter-spacing: 1px;
        color: #333333;
        line-height: 32px;
        margin-bottom: 10px;
      }

      .shuoming-title {
        width: 100%;
        font-size: 20px;
        letter-spacing: 1px;
        color: #1546c5;
        font-weight: bold;
        margin-bottom: 20px;
      }
    }
  }

  .head-box {
    width: 100%;
  }
}

.boxMain {
  width: 100%;
  background: #ffffff;
  // padding: 0 30px;
  // box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.03);
  // margin-top: 20px;
  // padding-bottom: 20px;

  .item-feedback {
    width: 100%;
    padding: 10px 0;
    //background-color: #f7f7f7;
    font-size: 16px;
    font-weight: bold;
    color: #ed3434;
    margin-top: 10px;

    span {
      color: #333333;
      font-weight: normal;
    }
  }

  .addbtn {
    width: 100%;
    display: flex;
    justify-content: center;

    span {
      width: 120px;
      height: 32px;
      background-color: #1546c5;
      border-radius: 0px 0px 10px 10px;
      text-align: center;
      line-height: 32px;
      font-size: 14px;
      letter-spacing: 1px;
      color: #ffffff;
      cursor: pointer;
    }
  }

  .tabel-box {
    width: 100%;
    padding: 20px 0;
  }

  .num-box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 52px;
    background-color: #ecf1ff;
    padding: 0 20px;
    margin: 20px 0;

    b {
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      span {
        color: #f56c6c;
        font-weight: normal;
        margin-right: 2px;
      }
    }

    span {
      font-size: 16px;
      color: #1546c5;
    }
  }

  .form-tit {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 30px 0;

    i {
      width: 8px;
      height: 22px;
      background-color: #1546c5;
      margin-right: 5px;
    }

    b {
      font-size: 20px;
      letter-spacing: 2px;
      color: #1546c5;
      font-weight: bold;
      span {
        font-size: 16px;
        color: red;
        margin-left: 0px;
        letter-spacing: 0;
        cursor: pointer;
        text-decoration-line: underline;
      }
    }
  }

  .titles {
    width: 100%;
    font-size: 16px;
    color: #333333;
    margin-bottom: 10px;

    b {
      color: #f56c6c;
      font-weight: normal;
    }
  }
}

.time_list_box {
  display: flex;
  align-content: center;
  flex-wrap: wrap;
}

.time_list_item {
  width: calc((100% - 40px) / 5);
  padding: 20px 10px;
  background: #eeeeee;
  margin-right: 10px;
  border-radius: 4px;
  color: #333333;
  font-size: 18px;
  font-weight: bold;
  /* flex-wrap: nowrap; */
  cursor: pointer;
  transition: all 0.3s;
  margin-top: 10px;
  margin-bottom: 10px;
  position: relative;
  /* 文字省略 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}

.time_list_item:nth-child(5n) {
  margin-right: 0;
}

.time_list_item_active {
  background: #1546c5;
  color: white;
}

/* 加一个下箭头在底部中间 背景颜色为#e7080a */
.time_list_item_active::before {
  content: "";
  position: absolute !important;
  bottom: 0;
  width: 0;
  height: 0;
  left: calc(50% - 12px);
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-top: 12px solid #1546c5;
  bottom: -12px;
}

.main {
  width: 100%;

  .curse-content {
    width: 100%;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-right: 15px;

    .curse-tex {
      font-size: 16px;
      color: #333333;
    }

    .curse-btn {
      width: 108px;
      height: 36px;
      background-color: #5298e2;
      border-radius: 10px 10px 0px 0px;
      text-align: center;
      line-height: 36px;
      font-size: 16px;
      color: #ffffff;
      cursor: pointer;
    }
  }

  .list-content {
    width: 100%;
    min-height: 500px;
    border: 1px solid #999999;
    background: #ffffff;
    border-radius: 20px;
    padding: 20px;
    margin-top: 15px;

    .item {
      width: 100%;
      padding: 20px 0;
      border-bottom: 1px solid #eceef0;
      .item-feedback {
        width: 100%;
        padding: 10px 15px;
        background-color: #f7f7f7;
        font-size: 14px;
        font-weight: bold;
        color: #ed3434;
        margin-top: 10px;
        span {
          color: #333333;
          font-weight: normal;
        }
      }
      .item-set {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .item-btnbox {
          flex: 1;
          margin-left: 50px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          .item-btn {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            cursor: pointer;
            font-size: 14px;
            color: #333333;
            margin-left: 20px;
            i {
              font-size: 16px;
              color: #333333;
              margin-right: 4px;
            }
          }
        }
        .item-look {
          width: 100px;
          height: 28px;
          border-radius: 6px;
          text-align: center;
          line-height: 28px;
          font-size: 14px;
          background-image: linear-gradient(90deg, #0115a6 0%, #1546c5 100%);
          margin-left: 15px;
          cursor: pointer;
          color: #ffffff;
        }
        .item-type {
          //width: 72px;
          padding: 0 10px;
          height: 28px;
          border-radius: 6px;
          text-align: center;
          line-height: 28px;
          font-size: 14px;
          &.grey {
            color: #999999;
            background-color: #f3f3f3;
          }
          &.red {
            color: #eb1d1d;
            background-color: #ffeded;
          }
          &.green {
            color: #1ea735;
            background-color: #e9f8e5;
          }
          &.blue {
            color: #3381c3;
            background-color: #e5eff8;
          }
        }
      }
      .item-time {
        width: 100%;
        font-size: 14px;
        color: #999999;
        margin: 10px 0;
      }
      .item-title {
        width: 100%;
        font-size: 16px;
        color: #333333;
      }
    }
  }
}
</style>
